import React from 'react';
import { Integration, IntegrationStatus } from '../../model';
import { API_URL } from '../../../api/api';
import './IntegrationWebhookInfo.scss';

export interface IntegrationWebhookInfoProps {
  integration: Integration | null;
  webHook: string | null;
  onCopyToClipboard: (text: string) => void;
}

const IntegrationWebhookInfo: React.FC<IntegrationWebhookInfoProps> = ({
  integration,
  webHook,
  onCopyToClipboard,
}) => {
  if (!integration || integration.status !== IntegrationStatus.ACTIVE) {
    return null;
  }

  const webhookResponse = `${API_URL}/external/webhook/${integration.uuid}`;

  return (
    <div className="integration-webhook-info">
      <h3>Webhook Configuration</h3>

      {integration.secretToken && (
        <div className="webhook-section">
          <h4>Send messages (POST) to webhook (click to copy):</h4>
          <div className="webhook-example">
            <p>Example request format:</p>
            <pre>{`{
    "id": "uuid of message",
    "chatId": "uuid chatId",
    "from": {
        "id": "string ID of user",
        "firstName": "nullable",
        "lastName": "nullable",
        "username": "nullable"
    },
    "text": "text of message"
}`}</pre>
          </div>
          <input
            type="text"
            value={webhookResponse}
            readOnly
            className="webhook-url"
            onClick={() => onCopyToClipboard(webhookResponse)}
            placeholder="Click to copy webhook URL"
          />
        </div>
      )}

      {integration.secretToken && (
        <div className="webhook-section">
          <h4>Secret Token - put in header "X-Signature" (click to copy):</h4>
          <input
            type="text"
            value={integration.secretToken}
            readOnly
            className="secret-token"
            onClick={() => onCopyToClipboard(integration.secretToken!)}
            placeholder="Click to copy secret token"
          />
        </div>
      )}

      {webHook && (
        <div className="webhook-section">
          <h4>Webhook URL:</h4>
          <textarea
            className="webhook-response"
            value={webHook}
            readOnly
            rows={10}
            placeholder="Webhook response data"
          />
        </div>
      )}
    </div>
  );
};

export default IntegrationWebhookInfo;
